import { render } from "./V7.vue?vue&type=template&id=41178ecc"
import script from "./V7.vue?vue&type=script&lang=ts"
export * from "./V7.vue?vue&type=script&lang=ts"
script.render = render

export default script